import getUncompletedSections from './getUncompletedSections';
import {DemandValidation} from "../constants/DemandValidation";
import {PublishConst} from "../constants/PublicationConst";
import {isDemandModification, isDemandPreparing} from "./getDemandStatus";
import {DemandValidationSectionStatus} from "../constants/DemandValidationSectionStatus";
import NationalNoticeStatus from "../components/complex/nationalNotice/constants/NationalNoticeStatus";
import EnoticeStatus from "constants/EnoticeStatus";

export default (demandValidation, ojsPublicationStatus, bzpContractNoticeStatus, isDemandChanged, enoticeStatus) => {
    if (!demandValidation) return false;
    if (!(isDemandPreparing() || (isDemandModification() && isDemandChanged && isDemandChanged.result))) {
        return false;
    }

    const uncompleted = getUncompletedSections(demandValidation);
    const hasUncompletedSections = uncompleted.length > 0;
    if (hasUncompletedSections) {
        return false;
    }

    const notice = demandValidation.find((x) => x.section === DemandValidation.NOTICE);
    const isNoticeAvailable = notice ? notice.status !== DemandValidationSectionStatus.UNAVAILABLE : false;
    if (isNoticeAvailable) {
        if (ojsPublicationStatus && (ojsPublicationStatus.status === PublishConst.PUBLISHED || ojsPublicationStatus.status === PublishConst.CONFIRMED || ojsPublicationStatus.status === PublishConst.UNAVAILABLE)) {
            return true;
        } else {
            return false;
        }
    }

    const nationalNotice = demandValidation.find((x) => x.section === DemandValidation.NATIONAL_NOTICE);
    const isNationalNoticeAvailable = nationalNotice ? nationalNotice.status !== 'UNAVAILABLE' : false;
    if (isNationalNoticeAvailable) {
        if (bzpContractNoticeStatus && (bzpContractNoticeStatus.status === NationalNoticeStatus.PUBLISHED || bzpContractNoticeStatus.status === NationalNoticeStatus.NONE)) {
            return true;
        } else {
            return false;
        }
    }

    const enotice = demandValidation.find((x) => x.section === DemandValidation.ENOTICES2);
    const isEnoticeAvailable = enotice ? enotice.status !== 'UNAVAILABLE' : false;
    if(isEnoticeAvailable){
        return enoticeStatus && enoticeStatus.ueNoticeStatus === EnoticeStatus.PUBLISHED;
    }

    return true;
}
